import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { CartDrawer } from '@/components/cart/CartDrawer';
import { MarketHeader } from './MarketHeader';
import { MarketFooter } from './MarketFooter';

/**
 * Public marketplace layout: shared header + footer + cart drawer around the
 * guest-accessible shopping pages (products, product detail, cart, checkout).
 */
export const MarketLayout = () => {
  return (
    <ThemeProvider>
      <div className="min-h-screen flex flex-col bg-white dark:bg-slate-900">
        <MarketHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <MarketFooter />
        <CartDrawer />
      </div>
    </ThemeProvider>
  );
};
